'use strict';
import angular from 'angular';

angular.module('exportbuilder.admin.directives', []);